import React from 'react';
import { NextPage } from 'next';

import { fetchWorldTaxonomy } from 'actions/worldTaxonomy';
import CamsAndForecasts from 'containers/CamsAndForecasts';
import { getOrCreateStore, type ReduxInitialProps } from 'stores';
import type { WavetrakPageContext } from 'types/wavetrak';

const CamsAndForecastsPage: NextPage<{}, ReduxInitialProps> = () => <CamsAndForecasts />;

CamsAndForecastsPage.getInitialProps = async (context: WavetrakPageContext) => {
  const store = getOrCreateStore();

  const { req } = context;
  const cookies = req?.cookies || {};

  const isServer = !!req;

  await store.dispatch(fetchWorldTaxonomy(cookies));

  if (isServer) {
    return {
      ssrReduxState: store.getState(),
    };
  }

  return {};
};

export default CamsAndForecastsPage;
